export default __webpack_public_path__ + "static/11-640c7e81f8f8c667f4b5aa6ac3c29bfc.png";